<script lang="ts" setup>
import { useSidebarStore } from "~/stores/sidebar";
import { useSearch } from "./utils";
import { CommandIcon, SearchIcon } from "lucide-vue-next";
import { useSidebar } from "../sidebar";

const { toggleSearch } = useSearch();

const { isMobile, open, openMobile, setOpenMobile } = useSidebar();
</script>

<template>
  <div>
    <Button
      variant="ghost"
      class="w-full h-8 bg-muted text-gray-500/60 rounded flex items-center justify-center overflow-hidden"
      @click="toggleSearch"
    >
      <template v-if="open">
        <span>Search...</span>
        <kbd class="ml-auto text-gray-500/80 text-sm shrink-0 flex items-center gap-1">
          <CommandIcon :size="12" />
          <span>K</span>
        </kbd>
      </template>
      <SearchIcon
        v-else
        name="search"
        :size="16"
        class="shrink-0"
      />
    </Button>
  </div>
</template>
